export const FILTER_TYPE = {
  applied: 'applied',
  current: 'current',
};
